import React, { createRef } from 'react';
import { MapLibreTool, MapTool } from "./tools";
import './index.scss';
import "./Map.scss";
import { Toast } from 'primereact/toast';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';

export class Map3d extends React.Component {

    id = this.props.id ?? "map";

    mapTool = new MapLibreTool();

    constructor(props) {

        super(props);

        this.toast = createRef(null);
    }

    render = () => {

        return <>

            <Toast ref={this.toast} />

            <div id={this.id} />
        </>;
    }

    componentDidMount = () => {

        // window.mapTokenKey = this.props.mapTokenKey;

        if (this.props.bms) {

            this.mapTool.setBmsKey(this.props.bms)
        }

        if (this.props.bingKey) {

            this.mapTool.setBingKey(this.props.bingKey)
        }

        this.mapTool.setGoogleKey(this.props.googleKey);

        this.mapTool.setYandexKey(this.props.yandexKey);

        this.mapTool.createMap(
            {
                ...{ id: this.id },
                ...this.props
            });


        this.mapTool.addBaseMap(this.props.baseMap ?? "NONE");
        
        if (this.props.sources) {

            this.mapTool.addDefaultSources(this.props.sources)
        }

        if (this.props.layers) {

            this.mapTool.addDefaultLayers(this.props.layers)
        }

    }
}

export default Map3d;
